import { render, staticRenderFns } from "./ViewBuild.vue?vue&type=template&id=be6a8c52&scoped=true&"
import script from "./ViewBuild.vue?vue&type=script&lang=js&"
export * from "./ViewBuild.vue?vue&type=script&lang=js&"
import style0 from "./ViewBuild.vue?vue&type=style&index=0&id=be6a8c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a8c52",
  null
  
)

export default component.exports